const React = require('react');

module.exports = React.createClass({
	
	render(){
		var className = 'row';
		
		return (
			<div className={className}>
				{this.props.children}
			</div>
		);
	}
});


/** WEBPACK FOOTER **
 ** ./src/components/row.js
 **/